/**
 * Resolve promise with value after the given delay
 * @param value value to be resolved
 * @param delay if delay <= 0, it will resolve immediatly
 */
export function promiseDelay(value, delay) {
    if (delay <= 0) {
        return Promise.resolve(value);
    }
    return new Promise((resolve, reject) => {
        setTimeout(() => resolve(value), delay);
    });
}
